import { applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
// import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';
// import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory as createHistory } from 'history'
import createSagaMiddleware from 'redux-saga';
import ReduxThunk from 'redux-thunk';
export const sagaMiddleware = createSagaMiddleware();
export const history = createHistory();

export default () => {
  const middleware: any[] = [sagaMiddleware, ReduxThunk]; // , routerMiddleware(history)]
  // const middleware: any[] = [sagaMiddleware];
  if (process.env.NODE_ENV !== 'production') {
    // This will check to make sure you don't incorrectly update your reducer (i.e. mutate state).
    // middleware.push(immutableStateInvariantMiddleware());
    middleware.push(createLogger({
      level: 'log',
      duration: true,
      collapsed: true,
      diff: true
    }));
  }
  return applyMiddleware(...middleware);
}
